export default __webpack_public_path__ + "60b749bd0065c285f28c49f6ae371ad6.png";